import { destroy,mutate,query, update } from "../../defaults/fetch";
import {useState,useEffect} from "react";

const BASE = "budget-category"
export const useGetAllBudgetCategories = () => {
    const getAllCategories = async () => {
        const url = `${BASE}/get-all`
        const { data } = await query(url)
        return data
    }

    return getAllCategories
}


export const useCreateBudgetCategory = () => {
    const createBudgetCategory = async (body) => {
        const url = `${BASE}/create`
        const { data } = await mutate(url, true, body)
        return data
    }

    return createBudgetCategory
}

export const useUpdateBudgetCategory = () => {
    const updateBudgetCategory = async (id, body) => {
        const url = `${BASE}/update/${id}`
        const { data } = await update(url, body)
        return data
    }

    return updateBudgetCategory
}


export const useDeleteBudgetCategory = ()=>{
    const deleteBudgetCategory = async(id)=>{
        const url = `${BASE}/delete/${id}`;
        const {data} = await destroy(url);
        return data;
    }
    return deleteBudgetCategory;
}
